import { useFeedback, useTranslation } from "@opendash/core";
import { Button } from "antd";
import { observer } from "mobx-react-lite";

import React, { useContext } from "react";
import { AgencyContext } from "../../contexts/AgencyContext";

import { ExportPageState } from "../ExportPageState";

export const ExportPage = observer(({ state }: { state: ExportPageState }) => {
  const t = useTranslation();
  const agencyState = useContext(AgencyContext);
  const [disabled, setDisabled] = React.useState(false);
  const { message } = useFeedback();

  console.log(state);

  async function doExport() {
    setDisabled(true);
    const hideMessage = message.loading("Starte Download...", 0);

    setDisabled(false);
    hideMessage();

    await state.downloadExport(agencyState.selectedAgency);

    message.success("Export wird heruntergeladen");
  }

  return (
    <div>
      <p>
        Exportieren Sie alle Daten, die zur Agency{" "}
        <b>{agencyState?.selectedAgency?.get("agency_name") || ""}</b> gehören
        in das definierte GTFS-Format. Sie können die Daten bspw. nutzen, um
        Ihre Fahrten bei Google zu hinterlegen.
      </p>
      <Button onClick={doExport} type="primary" disabled={disabled}>
        {t("gtfs:export.button.export")}
      </Button>
    </div>
  );
});
